<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t("autoTemplate") }}</h2>
		<el-divider></el-divider>
		<el-button @click="addtemplate" v-if="chatbot_setting_edit === '1'">{{ $t("addButton") }}</el-button>

		<template v-if="chatbot_setting_read === '1'">
			<br />
			<br />
			<el-collapse>
				<el-collapse-item :title="$t('searchByConditions')" name="1">

					<!-- implementation for search by branch -->
					<el-form ref="storeform" :model="storeform">
						<el-form-item :label="$t('selectStore')">
							<template>
								<div class="" style="display: flex">
									<el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
										<el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
										<el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
											:value="item.storeid"></el-option>
									</el-select>
								</div>
							</template>
						</el-form-item>
					</el-form>

					<!-- implementation for search by keywords -->
					<div>
						<el-form ref="keywordform" :model="keywordform">
							<el-form-item :label="$t('keyword')">
								<template>
									<div class="" style="display: flex">
										<el-input v-model="keywordform.keyword" clearable></el-input>
									</div>
								</template>
							</el-form-item>
						</el-form>
					</div>

					<!-- implementation for search by types -->
					<div>
						<el-form ref="typeform" :model="typeform">
							<el-form-item :label="$t('type')">
								<div style="display: flex">
									<el-select v-model="typeform.type" placeholder="">
										<el-option :label="$t('all')" value=""></el-option>
										<el-option v-for="option in typeOptions" :label="$t(option.label)"
											:value="option.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</el-form>
					</div>
					<el-button @click="filter()">{{ $t('search') }}</el-button>
				</el-collapse-item>
			</el-collapse>
			<br />
		</template>

		<!--        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->

		<template v-if="chatbot_setting_read === '1'">
			<el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" stripe
				@sort-change="sortChange" style="width: 100%">
				<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
				</el-table-column>
				<el-table-column prop="type" :label="$t('type')" sortable="custom" width="">
					<template slot-scope="scope">
						<div> {{ getTypeLabel(scope.row.type) }} </div>
					</template>
				</el-table-column>
				<el-table-column prop="sid" :label="$t('sid')" sortable="custom" width="">
				</el-table-column>
				<el-table-column prop="upmsg" :label="$t('keyword')" sortable="custom" width="">
				</el-table-column>
				<el-table-column prop="downmsg" :label="$t('downmsg')" sortable="custom" width="">
					<template slot-scope="scope">
						<div>{{ decodeString(scope.row.downmsg) }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('qrcode')" align="center" width="180">
					<template slot-scope="scope">
						<div class="operationVid">
							<el-button @click="ewm(scope.row.upmsg, scope.row.pageid, scope.row.storeid)">{{
								$t("qrcode")
							}}</el-button>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('adminset')" align="center" width="180">
					<template slot-scope="scope">
						<div class="operationVid">
							<el-button @click="edititem(scope.row)" v-if="chatbot_setting_edit === '1' && scope.row.type !== 'payment'">{{ $t("edit") }}</el-button>
							<el-button @click="delitem(scope.row.id)" v-if="chatbot_setting_edit === '1' && scope.row.type !== 'payment'">{{ $t("delete") }}</el-button>
							<span v-if="chatbot_setting_edit === '0'">{{ $t("NoPermissions") }}</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination flex-center">
				<span class="el-pagination__total">{{ $t("total") }} {{ tableData.length }} {{ $t("items") }}</span>
				<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-size="pageSize" layout="prev,pager,next" :total="tableData.length"></el-pagination>
			</div>
		</template>
		<template v-if="chatbot_setting_read === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>

		<!-- add -->
		<el-dialog :title="$t('addButton')" :visible.sync="dialogVisible"
			:width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">

					<!--
					<el-form-item :label="$t('dianpulist')">
						<el-select v-model="form.pageid" placeholder="">
							<el-option v-for="item in pagelist" :label="item.name" :value="item.pageid"></el-option>

						</el-select>
					</el-form-item>-->

					<el-form-item :label="$t('storeList')">
						<el-select v-model="form.storeid" placeholder="" @change="changeStoreid">
							<el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
						</el-select>
					</el-form-item>

					<template v-if="is_marketplace === '1'">
						<el-form-item label="NoWait MarketPlace ID">
							<el-select v-model="form.marketplaceid" placeholder="">
								<el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
							</el-select>
						</el-form-item>
					</template>

					<el-form-item :label="$t('autoreplyType')">
						<el-select v-model="form.type" placeholder="">
							<el-option :label="$t('txt')" value="txt"></el-option>
							<!--<el-option :label="$t('tianqi')" value="tianqi"></el-option>
							<el-option :label="$t('paidui')" value="paidui"></el-option>
							<el-option :label="$t('huodong')" value="huodong1"></el-option>-->
							<el-option :label="$t('huodongyhq')" value="huodongyhq"></el-option>
							<el-option :label="$t('location')" value="location"></el-option>
							<el-option :label="$t('image')" value="image"></el-option>
							<el-option :label="$t('video')" value="video"></el-option>
							<el-option :label="$t('pdfFile')" value="pdf"></el-option>
							<el-option :label="$t('templates')" value="template"></el-option>
							<el-option :label="$t('button')" value="button"></el-option>
							<el-option :label="$t('ctabutton')" value="ctaurl"></el-option>
							<el-option :label="$t('selectList')" value="list"></el-option>
							<!--<el-option :label="$t('payButton')" value="payment"></el-option>-->
							<el-option :label="$t('huodongyhqpos')" value="huodongyhqpos"></el-option>
                            <el-option :label="$t('shoppingflow')" value="shopping_flow"></el-option>
                            <el-option :label="$t('epos_order')" value="epos_order"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="$t('valid') + '/' + $t('invalid')">
						<el-select v-model="form.privately" placeholder="">
							<!--
							<el-option :label="$t('true')" value="1"></el-option>
							<el-option label="$t('false')" value="0"></el-option>-->
							<el-option :label="$t('valid')" value="0"></el-option>
							<el-option :label="$t('invalid')" value="1"></el-option>

						</el-select>
					</el-form-item>

					<el-form-item v-if="form.type == 'huodongyhq'" :label="$t('activity')">
						<el-select v-model="form.huodongID" placeholder="">
							<el-option v-for="item in huodonglist" :label="item.title" :value="item.id"></el-option>

						</el-select>
					</el-form-item>


					<el-form-item v-if="form.type == 'huodongyhqpos'" :label="$t('activity')">
						<el-select v-model="form.huodongArray" :placeholder="$t('pleaseSelect')" multiple>
							<el-option v-for="item in huodonglist" :label="item.title" :value="item.id"></el-option>

						</el-select>
					</el-form-item>

                    


					


					<el-form-item :label="$t('keyword')">
						<el-input v-model="form.upmsg" @input="(val) => form.upmsg = val.toUpperCase()"></el-input>
					</el-form-item>

                    <el-form-item v-if="form.type == 'shopping_flow'" :label="$t('product')">
						<el-select v-model="form.huodongID" :placeholder="$t('pleaseSelect')">
							<el-option v-for="item in productlist" :label="item.goods_name" :value="item.id"></el-option>

						</el-select>
					</el-form-item>

					<el-form-item v-if="form.type == 'button' || form.type == 'ctaurl' || form.type == 'pdf' || form.type == 'list' || form.type == 'epos_order'"
						:label="$t('title')">
						<el-input v-model="form.header"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 'image' || form.type == 'button'" :label="$t('uploadImage')">
						<el-input v-model="form.image"></el-input>
						<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
							:http-request="uploadSectionFile" :on-remove="handleRemove">
							<i slot="default" class="el-icon-plus" />
							<div slot="file" slot-scope="{file}">
								<el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
								<span class="el-upload-list__item-actions">
									<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
										<i class="el-icon-zoom-in" />
									</span>
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleDownload(file)">
										<i class="el-icon-download" />
									</span>
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleRemove(file)">
										<i class="el-icon-delete" />
									</span>
								</span>
							</div>
						</el-upload>

						<!-- <el-image-viewer :z-index="2002" v-if="showViewer" :on-close="closeViewer" :url-list="[dialogImageUrl]"/> -->



					</el-form-item>

					<el-form-item v-if="form.type == 'pdf'" :label="$t('uploadPdf')">
						<el-input v-model="form.image"></el-input>
						<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
							:http-request="uploadSectionPDFFile" :on-remove="handleRemove">
							<i slot="default" class="el-icon-plus" />
							<div slot="file" slot-scope="{file}">
								<span class="el-upload-list__item-actions">
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleDownload(file)">
										<i class="el-icon-download" />
									</span>
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleRemove(file)">
										<i class="el-icon-delete" />
									</span>
								</span>
							</div>
						</el-upload>

						<!-- <el-image-viewer :z-index="2002" v-if="showViewer" :on-close="closeViewer" :url-list="[dialogImageUrl]"/> -->



					</el-form-item>


					<!-- 				
				  <el-form-item v-if="form.type=='template'" label="圖片地址[注意:如範本没有圖片,则不要填写]">
                        <el-input v-model="form.head_img"></el-input>
			 	
                    </el-form-item>
					 -->

					<el-form-item v-if="form.type == 'video'" :label="$t('videoUrl')">
						<el-input v-model="form.image"></el-input>
					</el-form-item>

                    <el-form-item v-if="form.type == 'ctaurl' || form.type == 'epos_order'" :label="$t('ctaText')">
						<el-input v-model="form.ctatext"></el-input>
					</el-form-item>

                    <el-form-item v-if="form.type == 'ctaurl'" :label="$t('ctaUrl')">
						<el-input v-model="form.ctaurl"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 'button' || form.type == 'list'" :label="$t('list')">
						<el-input v-model="form.buttonlist"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 'list'" :label="$t('listDestination')">
						<el-input v-model="form.list_des"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 'list'" :label="$t('listButton')">
						<el-input v-model="form.list_button"></el-input>
					</el-form-item>

					<el-form-item
						v-if="form.type == 'txt' || form.type == 'image' || form.type == 'pdf' || form.type == 'button' || form.type == 'ctaurl' || form.type == 'list' || form.type == 'epos_order'"
						:label="$t('downmsg')">
						<el-input type="textarea" :rows="5" v-model="tempDownmsg">
						</el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 'button' || form.type == 'ctaurl' || form.type == 'list' || form.type == 'epos_order'" :label="$t('bottom')">
						<el-input v-model="form.footer" type="textarea" :rows="2"></el-input>
					</el-form-item>


					<!-- <el-form-item v-if="form.type=='template'" label="範本ID">
						<el-input v-model="form.downmsg" type="textarea" :rows="1"></el-input>
					</el-form-item>


					<el-form-item v-if="form.type=='template'" label="變化文字1">
						<el-input v-model="form.msg1" type="textarea" :rows="2"></el-input>
					</el-form-item>


					<el-form-item v-if="form.type=='template'" label="變化文字2">
						<el-input v-model="form.msg2" type="textarea" :rows="2"></el-input>
					</el-form-item> -->

					<el-form-item v-if="form.type=='template'" :label="$t('selectTemplates')">
						<el-select  v-model="form.metatemplateid" :placeholder="$t('pleaseSelect')">
						<el-option
							v-for="item in metaTemplateList"
							:key="item.id"
							:label="item.template_name"
							:value="item.id">
						</el-option>
						</el-select>
					</el-form-item>

					<el-form-item v-if="form.type=='location'" :label="$t('longitude')">
						<el-input v-model="form.longitude" type="textarea" :rows="1"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type=='location'" :label="$t('latitude')">
						<el-input v-model="form.latitude" type="textarea" :rows="1"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type=='location'" :label="$t('locationName')">
						<el-input v-model="form.location_name" type="textarea" :rows="1"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type=='location'" :label="$t('locationAddress')">
						<el-input v-model="form.location_address" type="textarea" :rows="1"></el-input>
					</el-form-item>


                    <el-form-item :label="$t('epos_order_type')" v-if="form.type == 'epos_order'">
						<el-select v-model="form.huodongID" placeholder="" :placeholder="$t('pleaseSelect')">
							<el-option :label="$t('epos_order_1')" value="1"></el-option>
							<el-option :label="$t('epos_order_2')" value="2"></el-option>

						</el-select>
					</el-form-item>

                    <el-form-item v-if="form.type == 'epos_order'" :label="$t('epos_order_desk')">
						<el-input v-model="form.city" type="textarea" :rows="1"></el-input>
					</el-form-item>


                    <el-form-item :label="$t('isdefault')">
						<el-select v-model="form.is_default" placeholder="">
							<!--
							<el-option :label="$t('true')" value="1"></el-option>
							<el-option label="$t('false')" value="0"></el-option>-->
							<el-option :label="$t('yes')" value="1"></el-option>
							<el-option :label="$t('no')" value="0"></el-option>

						</el-select>
					</el-form-item>


					<el-form-item :label="$t('sid')">
						<el-input v-model="form.sid" type="textarea" :rows="1"></el-input>
					</el-form-item>




					<!-- <el-form-item v-if="form.type == 2">
                        <img width="100%" :src="form.pic" alt="">
                        <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove">
                             <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="sure">{{ $t('Sure') }}</el-button>
				<!-- <el-button v-if="form.type != 1"  type="primary" @click="submitImportForm">{{$t('Sure')}}{{form.type}}</el-button> -->
			</span>
		</el-dialog>


		<el-dialog :title="$t('qrcode')" :visible.sync="dialogVisible_ewm" width="556px" :before-close="handleClose">
			<div class="add-template">


				<div>Whatsapp:<a :href="ewmdata.wurl">Link</a>
					<!-- 	<button class="tag-read" :data-clipboard-text="ewmdata.wurl" @click="copy">复制</button> -->
					<div><img :src="ewmdata.whatsapp" :style="'width:100%'" /></div>
				</div>


			</div>
		</el-dialog>


	</div>
</template>
<script>
import {
	formatDate
} from '../../assets/date.js'
import axios from 'axios'
import {
	tongyong,
	funk,
	imageUpload,
	getMetaTemplate,
	getStore
} from '@/api'
import {
	addAutoTemplate,
    getShopProduct
} from '@/api'
// import { filter } from 'core-js/core/array';
export default {
	data() {
		return {
			chatbot_setting_read: '0',
			chatbot_setting_edit: '0',
			exportcsv: '0',
			qyid: '',
            storeid: '',
			is_marketplace: 0,
			marketplaceid: null,
			dialogImageUrl: '',
			fileList: [],
			disabled: false,
			showViewer: false, // 显示查看器
			ewmdata: [],
			fileList: [],
			pagelist: [],
			storelist: [],
			huodonglist: [],
            productlist: [],
			currentPage: 1, // 当前页码
			pageSize: 20, // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogVisible_ewm: false,
            dialogVisible_default: false,
			tab: [{
				label: this.$t('underApproval'),
				id: '0'
			},
			{
				label: this.$t('passed'),
				id: '1'
			}
			],
			tableData: [],
			tableData1: [

				{
					timer: '2018-01-01',
					name: '测试範本001',
					status: '审核中'
				},
			],
			metaTemplateList: [],
			status: 0,
			form: {
				type: 'txt',
				upmsg: '',
				downmsg: '',
				sid: 0,
				qyid: '',
				pageid: '',
				storeid: ''
			},
            form_default: {
				type: 'txt',
				upmsg: '',
				downmsg: '',
				sid: 0,
				qyid: '',
				pageid: '',
				storeid: ''
			},
			tempDownmsg: '',
			storeform: {
				storeid: '',
				businesswhatsapp: '',
			},
			keywordform: {
				keyword: ''
			},
			typeOptions: [
				{ label: 'huodongyhq', value: 'huodongyhq' },
				{ label: 'huodongyhqpos', value: 'huodongyhqpos' },
				{ label: 'image', value: 'image' },
				{ label: 'video', value: 'video' },
				{ label: 'location', value: 'location' },
				{ label: 'wenzi', value: 'txt' },
				{ label: 'pdfFile', value: 'pdf' },
				{ label: 'templates', value: 'template' },
				{ label: 'button', value: 'button' },
				{ label: 'selectList', value: 'list' },
				{ label: 'payButton', value: 'payment' },
				{ label: 'ctabutton', value: 'ctaurl' },
                { label: 'shoppingflow', value: 'shopping_flow' },
                { label: 'bookingflow', value: 'booking_flow' },
                { label: 'epos_order', value: 'epos_order' },
			],
			typeform: {
				type: ''
			},
		}
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000 //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},
	watch: {
		// Watch for changes in form.downmsg to update tempDownmsg with formatted value
		'form.downmsg': {
			immediate: true,
			handler(newVal) {
				this.tempDownmsg = newVal ? this.decodeString(newVal) : '';
			}
		}
	},
	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
		this.is_marketplace = auser.is_marketplace
		//console.log('is_marketplace: ' + auser.is_marketplace)
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.chatbot_setting_read = auser.chatbot_setting_read
    	this.chatbot_setting_edit = auser.chatbot_setting_edit
    	this.exportcsv = auser.exportcsv
		this.gettemplist(auser.storeid)
		this.getpagelist()
		this.getstorelist()
		this.gethuodonglist()
        this.getproductlist()
		this.getMetaTemplateList()
	},
	methods: {
        defaulttemplate() {
			this.dialogVisible_default = true
			this.form_default = {}
		},
		addtemplate() {
			this.dialogVisible = true
			this.form = {}
		},
		edititem(data) {
			this.form = data
			this.dialogVisible = true
		},
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist(this.storeform.storeid)
		},
		handleClose() {
			this.dialogVisible = false
			this.dialogVisible_ewm = false
            this.dialogVisible_default = false
		},
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
		changeTableStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			//console.log('storeid:' + this.storeform.businesswhatsapp)
			this.gettemplist(this.storeform.storeid)
		},
		changeStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			this.getMetaTemplateList()
			this.gethuodonglist()
			this.gettemplist(this.storeform.storeid)
		},
		filter() {
			console.log('filter')
			this.gettemplist(this.storeform.storeid)
		},
		getTypeLabel(typeValue) {
			const option = this.typeOptions.find(option => option.value === typeValue);
			return option ? this.$t(option.label) : '';
		},
		getMetaTemplateList() {
			this.show = true
			console.log("go list");
			var user = JSON.parse(window.localStorage.getItem("userinfo"));

			let fdata = {
				qyid: this.qyid,
				storeid: this.form.storeid
			};
			getMetaTemplate(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.metaTemplateList = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		handleUppercase(value) {
			this.form.upmsg.value = value.toUpperCase()
		},
		decodeString(str) {
			if (!str) {
				return str || '';
			}

			return str
				.replace(/\\u[\dA-F]{4}/gi, function (match) {
					return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
				})
				.replace(/\\n/g, '\n');
		},
		encodeString(str) {
			str = str.replace(/\n/g, '\\n');

			return str.split('').map(function (char) {
				const code = char.charCodeAt(0);
				if (code > 127) {
					return '\\u' + code.toString(16).padStart(4, '0');
				}
				return char;
			}).join('');
		},
		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			//this.form.qyid = user.id
            this.form.qyid = this.qyid
			this.form.downmsg = this.encodeString(this.tempDownmsg);

			console.log("this.form.huodongArray: " + this.form.huodongArray);
			//console.log("this.form.huodongArray2: " + implode(',', this.form.huodongArray));
			
			addAutoTemplate(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist(this.storeform.storeid)
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				let fdata = {
					sjk: 'messenger_autolist',
					action: 'del',
					id: id
				}
				tongyong(fdata).then(res => {
					if (res.code == 1) {
						console.log(res);
						this.gettemplist(this.storeform.storeid)
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}).catch(_ => {



			})


		},
		// 我的範本列表
		gettemplist(storeid) {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'));

			let fdata = {
				sjk: 'messenger_autolist',
				action: 'list',
				//qyid: user.id,
                qyid: this.qyid,
				storeid: storeid,
			};

			let moresearch = [];

			if (this.typeform.type) {
				moresearch.push('type');
				fdata.type = this.typeform.type;
			}
			if (this.keywordform.keyword) {
				moresearch.push('upmsg');
				fdata.upmsg = this.keywordform.keyword;
			}

			if (moresearch.length > 0) {
				fdata.moresearch = moresearch.join(',').replace(/\s+/g, '');
				console.log(fdata.moresearch);
			}

			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data;
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
			});
		},



		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				//qyid: user.id
                qyid: this.qyid
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		getstorelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				qyid: this.qyid,
                storeid: this.storeid
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.storelist = res.data
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},

		//pagelist 
		gethuodonglist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',
				//qyid: user.id,
                qyid: this.qyid,
				storeid: this.form.storeid
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.huodonglist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
        getproductlist() {
            let fdata = {
                //qyid: user.id,
                qyid: this.qyid,
                storeid: this.form.storeid
            };
            getShopProduct(fdata).then((res) => {
                if (res.code == 1) {
                    this.productlist = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },


		ewm(str, pageid, storeid) {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			console.log('evmmmmmmmmm');
			console.log(storeid);
			this.dialogVisible_ewm = true
			//this.qyid = user.id
			let fdata = {
				do: 'ewm_2',
				qyid: this.qyid,
				pageid: pageid,
				storeid: storeid,
				ref: str,
				type: 'link',


			}
			console.log('go ewm', fdata);


			funk(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.ewmdata = res
					console.log(this.ewmdata)
					// const html ='<div style="text-algin:center;">H5:<a target="_blank"  href="'+res.url+'">link</a> <br><img src='+res.path+' /> <br>Whatsapp:<a target="_blank"  href="'+res.wurl+'">link</a> <button class="tag-read" :data-clipboard-text="aaa" @click="copy">复制</button></el-button><br> <img src='+res.whatsapp+' /> <br></div>' 
					// this.$alert(html, '預約排隊二維碼', {
					//           dangerouslyUseHTMLString: true
					//         });


				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//上传--

		// 删除
		handleRemove(file) {
			let uploadFiles = this.$refs.elUpload.uploadFiles;
			uploadFiles.forEach((value, index) => {
				if (value.uid === file.uid) {
					uploadFiles.splice(index, 1)
					this.fileList.splice(index, 1)
				}
			})
		},
		// 大图预览
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.showViewer = true;
		},
		// 下载圖片
		handleDownload(file) {
			let a = document.createElement('a');
			a.download = file.name;
			a.href = (file.url);
			a.click();
		},
		// 重写上传
		uploadSectionFile(params) {
			const file = params.file,
				fileType = file.type,
				isImage = fileType.indexOf('image') !== -1,
				isLt2M = file.size / 1024 / 1024 < 2;

			if (fileType.indexOf('pdf') !== -1) {
				console.log('File type is PDF');
			} else {
				console.log('File type is not PDF');
			}
			// 这里常规检验，看项目需求而定
			if (!isImage) {
				this.$message.error(this.$t('imageFormatOnly'));
				return;
			}
			if (!isLt2M) {
				this.$message.error(this.$t('imageSizeOnly'));
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.image = res
			}).catch(() => {
				// xxx
			});
		},
		uploadSectionPDFFile(params) {
			const file = params.file,
				fileType = file.type,
				isPdf = fileType.indexOf('pdf') !== -1,
				isLt5M = file.size / 1024 / 1024 < 5;

			// 这里常规检验，看项目需求而定
			if (!isPdf) {
				this.$message.error(this.$t('pdfOnly'));
				return;
			}
			if (!isLt5M) {
				this.$message.error(this.$t('pdf<5mb'));
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.image = res
			}).catch(() => {
				// xxx
			});
		},
		// 关闭
		closeViewer() {
			this.showViewer = false;
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}
</style>
